@if (isOpen) {
  <dialog
    class="modal-overlay"
    tabindex="-1"
    (click)="onClose()"
    (keydown.escape)="onClose()"
    aria-modal="true"
    [attr.aria-label]="title ?? 'Vista Previa'"
    open
  >
    <div
      class="modal-content"
      [ngStyle]="getModalStyles()"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      tabindex="0"
    >
      @if (title) {
        <div class="modal-header">
          <h3>{{ title }}</h3>
          <button
            class="close-button"
            (click)="onClose()"
            aria-label="Cerrar modal"
            type="button"
          >
            <span class="icon-equis" aria-hidden="true"></span>
          </button>
        </div>
      }
      <div class="modal-body">
        <!-- Proyección de contenido -->
        <ng-content></ng-content>

        <!-- Fallback para contenido con @Input data (mantener compatibilidad) -->
        @if (data) {
          @if (isTable(data)) {
            <table aria-label="Tabla de datos">
              <thead>
                <tr>
                  @for (header of data[0]; track $index) {
                    <th>{{ header }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of data.slice(1); track $index) {
                  <tr>
                    @for (cell of row; track $index) {
                      <td>{{ cell }}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <p>{{ data }}</p>
          }
        }
      </div>
    </div>
  </dialog>
}
